export const frameColorsForRender = window.frameColorsForRender ?? {};
